	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS;


//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs/ref/index.js
// module id = 5
// module chunks = 0